module.exports = __webpack_public_path__ + "static/carousel-dark.f3121f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-dark.jpg
// module id = 340
// module chunks = 35783957827783